import { PAYMENT_STATUS, ACCOUNT_TYPES, PAYMENT_SOURCES } from './Paymenthistoryconstants';

export const formatAmount = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};

export const formatForeignCurrency = (amount, currency) => {
    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};

export const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString("tr-TR", {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
};

export const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString("tr-TR") : "-";
};

export const getPaymentStatusText = (status) => {
    const statusObj = Object.values(PAYMENT_STATUS).find(s => s.key === status);
    return statusObj ? statusObj.label : status;
};

export const getPaymentStatusColor = (status) => {
    const statusObj = Object.values(PAYMENT_STATUS).find(s => s.key === status);
    return statusObj ? statusObj.color : 'secondary';
};

export const getAccountTypeText = (accountType) => {
    return ACCOUNT_TYPES[accountType] || accountType || '-';
};

// Ödemenin geldiği akış (Anlık / Firma / Fatura ile Tahsilat). Eski kayıtlarda alan
// boş gelebilir; o durumda tire basılır, ham enum adı gösterilmez.
export const getPaymentSourceText = (paymentSource) => {
    const source = PAYMENT_SOURCES.find(s => s.key === paymentSource);
    return source ? source.label : '-';
};

// Tahsilat tipi etiketi ve chip rengi — hem tabloda hem detay panelinde kullanılır
export const getReceiptTypeText = (receiptType) => {
    switch (receiptType) {
        case "CASH": return "Nakit";
        case "CREDIT_CARD": return "Kredi Kartı";
        case "BANK_TRANSFER": return "Havale/EFT";
        case "CHECK": return "Çek";
        case "PROMISSORY_NOTE": return "Senet";
        default: return "-";
    }
};

/** "Tahsilat Tipi" kolonunun çipi; tip yoksa null. */
export const getCollectionTypeChip = (payment) => {
    const source = PAYMENT_SOURCES.find(s => s.key === payment?.paymentSource);
    return source ? { label: source.label, chipClass: source.chipClass } : null;
};

export const receiptTypeToChipClass = (receiptType) => {
    switch (receiptType) {
        case "CASH": return "chip-green";
        case "CREDIT_CARD": return "chip-navy-solid";
        case "BANK_TRANSFER": return "chip-amber";
        case "CHECK": return "chip-gray";
        case "PROMISSORY_NOTE": return "chip-navy";
        default: return "chip-gray";
    }
};

export const statusToChipClass = (status) => {
    switch (status) {
        case "SUCCESS": return "chip-green";
        case "PENDING": return "chip-amber";
        case "FAILED": return "chip-red";
        case "PARTIALLY_REFUNDED": return "chip-amber";
        case "REFUNDED": return "chip-gray";
        default: return "chip-gray";
    }
};

export const getPaginationNumbers = (currentPage, totalPages) => {
    const pages = [];
    const maxDisplay = 5;
    let start = Math.max(0, currentPage - Math.floor(maxDisplay / 2));
    let end = Math.min(totalPages - 1, start + maxDisplay - 1);
    if (end - start + 1 < maxDisplay) start = Math.max(0, end - maxDisplay + 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
};

export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text ?? "");
        return true;
    } catch (e) {
        const ta = document.createElement('textarea');
        ta.value = text ?? "";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        return true;
    }
};